import { MetricCard, MetricGrid } from "@nymbl/nos2-rules";
import type { ExpenseCard } from "@/lib/expenses/cards";
import { formatMoney } from "@/lib/expenses/view";

/** Stipends left, Approved, Pending payment. Only cards with something to say are sent. */
export function ExpenseCards({ cards }: { cards: ExpenseCard[] }) {
  if (cards.length === 0) return null;
  return (
    <MetricGrid>
      {cards.map((c) => (
        <MetricCard
          key={c.key}
          label={c.label}
          value={formatMoney(c.amount)}
          detail={c.of === null ? undefined : `of ${formatMoney(c.of)}`}
          alert={c.amount < 0}
          alertLabel="Over"
        />
      ))}
    </MetricGrid>
  );
}
